import * as Mutation from './mutation-types'
import AgendaApi from "@/services/agendaApi"

export default {
  async getAgenda({commit}, dateRange) {
    commit(Mutation.START_LOADING)
    commit(Mutation.GET_AGENDA, {})
    let {agenda} = await AgendaApi.getAgenda(dateRange)
    commit(Mutation.GET_AGENDA, agenda)
    commit(Mutation.STOP_LOADING)
  },
  async deleteCronograma({commit}, cronogramaId) {
    commit(Mutation.START_LOADING)
    let response = await AgendaApi.delete(cronogramaId)
    if (!response.errors) {
      commit(Mutation.DELETE_CRONOGRAMA, cronogramaId)
    }
    commit(Mutation.STOP_LOADING)
    return response
  },
  removeEventDay({commit}, eventDayId) {
    commit(Mutation.REMOVE_EVENT_DAY, eventDayId)
  },
  updateScheduleDates({commit}, scheduleId) {
    commit(Mutation.UPDATE_SCHEDULE_DATES, scheduleId)
  },
  setCurrentDay({commit}, currentDay) {
    return commit(Mutation.SET_CURRENT_DAY, currentDay)
  },
  setDateRange({commit}, dateRange) {
    return commit(Mutation.SET_DATE_RANGE, dateRange)
  },
  startLoading({commit}) {
    commit(Mutation.START_LOADING)
  },
  stopLoading({commit}) {
    commit(Mutation.STOP_LOADING)
  },
}
